import { DEFAULT_DEPLOY_TIME_OF_DAY } from '../constants/availabilityModes'
import { TIMING_MODE } from '../constants/timingMode'

const normalizeClock = value => {
  if (!value) return null
  const text = String(value).trim()
  if (!text) return null
  const match = text.match(/^(\d{1,2}):(\d{2})/)
  if (!match) return null
  const hours = String(Number(match[1])).padStart(2, '0')
  const minutes = match[2]
  return `${hours}:${minutes}`
}

/** Anchor supplies an explicit deploy clock only in elapsed-time mode with a time on the offset. */
export const anchorSpecifiesDeployTime = anchor => {
  if (!anchor || anchor.timingMode !== TIMING_MODE.elapsedTime) return false
  return Boolean(normalizeClock(anchor.deployTime) || normalizeClock(anchor.offset?.time))
}

/**
 * Deploy `time_of_day` for the schedule API.
 * Daily window start wins when enabled; otherwise explicit schedule/anchor clock, else 09:00.
 */
export const resolveDeployTimeOfDay = (schedule = {}) => {
  const daily = schedule?.availability?.dailyWindow
  if (daily?.enabled) {
    const fromDaily = normalizeClock(daily.from)
    if (fromDaily) return fromDaily
  }

  const anchor = schedule?.anchors?.[0]
  if (anchorSpecifiesDeployTime(anchor)) {
    const fromAnchor = normalizeClock(anchor.deployTime) || normalizeClock(anchor.offset?.time)
    if (fromAnchor) return fromAnchor
  }

  const fromSchedule = normalizeClock(schedule.timeOfDay)
  if (fromSchedule) return fromSchedule

  return DEFAULT_DEPLOY_TIME_OF_DAY
}
